module.exports = __webpack_public_path__ + "toBride2-jp-w-b.8d338dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-jp-w-b.jpg
// module id = mkPW
// module chunks = 0